<div class="editable-row-card-container" [class.disabled]="cardItem().isArchived()">
  <div class="row d-flex align-items-center justify-content-between flex-grow-1">
    <div class="col-7 d-flex align-items-center">
      @if (cardItem().isEditing()) {
        <div class="w-100">
          <form [formGroup]="formGroup" (keydown.enter)="saveClicked()">
            <div class="d-flex align-items-center w-100 gap-2">
              <lib-text-input
                [inputSize]="InputSize.small"
                class="d-block flex-grow-1"
                [error]="inputFormControl.invalid"
                [controlId]="inputId"
                [formControl]="inputFormControl">
              </lib-text-input>
              <lib-button
                [type]="ButtonType.primary"
                [size]="InputSize.small"
                (buttonClick)="saveClicked()"
                [loading]="isSaving()"
                i18n>
                Save
              </lib-button>
            </div>
          </form>
          @if (inputFormControl.invalid) {
            <lib-form-error class="d-block mt-1" [errors]="inputFormControl.errors"></lib-form-error>
          }
        </div>
      } @else {
        <div class="editable-row-card-title">
          @if (cardItem().showCheckbox() && !cardItem().isArchived()) {
            <lib-checkbox (checkboxClick)="checkboxClicked()" [selected]="cardItem().isChecked()"></lib-checkbox>
          }
          <div class="font-label-large font-medium">
            {{ cardItem().name() }}
          </div>
        </div>
      }
    </div>
    <div class="col d-flex align-items-center justify-content-end">
      <div class="d-flex gap-3">
        @if (!cardItem().isArchived()) {
          <lib-button
            [type]="ButtonType.tertiary"
            [size]="InputSize.small"
            (buttonClick)="cancel()"
            [hidden]="!cardItem().isEditing() || cardItem().readOnly"
            [disabled]="isSaving()"
            i18n>
            Cancel
          </lib-button>
          <lib-button
            [leadingIconName]="'edit-square'"
            [type]="ButtonType.tertiary"
            [size]="InputSize.small"
            (buttonClick)="editClicked()"
            [hidden]="cardItem().isEditing() || cardItem().readOnly"
            [disabled]="isSaving() || cardItem().showCheckbox()"
            i18n>
            Edit
          </lib-button>
          <lib-button
            [leadingIconName]="'archive'"
            [type]="ButtonType.tertiary"
            [size]="InputSize.small"
            (buttonClick)="archiveClicked()"
            [hidden]="cardItem().readOnly"
            [disabled]="isSaving() || (cardItem().showCheckbox() && !cardItem().isChecked())"
            i18n>
            Archive
          </lib-button>
        } @else {
          <lib-general-status-pill [type]="StatusPillType.grey" i18n>Archived</lib-general-status-pill>
        }
      </div>
    </div>
  </div>
</div>
